<template>
    <div class="filter-box">
        <shopFilterCities v-on:changeFilter="changeValue"></shopFilterCities>
        <acquiring v-on:changeFilter="changeValue"></acquiring>
        <shift v-on:changeFilter="changeValue"></shift>
        <status v-on:changeFilter="changeValue"></status>
        <search class="status" v-on:changeFilter="changeValue"></search>
    </div>
</template>

<script>
import shopFilterCities from '../common/filters/shop/cities'
import acquiring from '../common/filters/shop/acquiring'
import shift from '../common/filters/shop/shift'
import status from '../common/filters/shop/status'
import search from '../common/filters/shop/search'

export default {
  name: 'ShopFilter',
  components: { search, acquiring, shopFilterCities, shift, status },
  methods: {
    changeValue () {
      this.$emit('changeFilter')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shops/ShopFilter.vue